// extracted by mini-css-extract-plugin
export var addViewLink = "_19-1";
export var availabilityIcon = "_19-16";
export var availabilitySelectionIcon = "_19-15";
export var backButton = "_19-2";
export var backIcon = "_19-z";
export var conversationCount = "_19-3";
export var dragHandle = "_19-5";
export var dropdown = "_19-e";
export var dropdownIcon = "_19-7";
export var dropdownOption = "_19-6";
export var dropdownTriangle = "_19-d";
export var expand = "_19-f";
export var folder = "_19-i";
export var folderItem = "_19-c";
export var icon = "_19-8";
export var iconRow = "_19-9";
export var image = "_19-a";
export var logo = "_19-b";
export var navContainer = "_19-h";
export var navigationFooter = "_19-g";
export var pageShell = "_19-0";
export var placeholderAvailable = "_19-11";
export var placeholderBox = "_19-14";
export var placeholderBusy = "_19-13";
export var placeholderUnavailable = "_19-12";
export var profile = "_19-k";
export var profileContainer = "_19-m";
export var profileDropdown = "_19-n";
export var profileImage = "_19-l";
export var profileMain = "_19-o";
export var profileSubtitle = "_19-q";
export var profileTitle = "_19-p";
export var reorderIcon = "_19-r";
export var sentLine = "_19-u";
export var settingsHeader = "_19-s";
export var sidenavTextColor = "_19-y";
export var spamLine = "_19-t";
export var subitemWithTag = "_19-4";
export var supportItems = "_19-j";
export var teamText = "_19-10";
export var viewLine = "_19-x";
export var viewLineButton = "_19-w";
export var viewLineButtons = "_19-v";